<template>
  <div class="inputView__layer">
    <div class="inputView__layer__arrow" :style="`margin-left:${offsetLeft}px`"></div>
    <div class="inputView__layer__content">
      <div class="inputView__layer__header">
        <img class="inputView__layer__header__close" :src="images.close" @click="closeLayerView()" />
      </div>

      <div class="inputView__layer__photos" v-if="['photo', 'comment_photo', 'piskel'].includes(type)">
        <div
          class="inputView__layer__photo"
          v-for="(item, index) in layer_photos"
          :key="index"
          :style="`background-image:url(${item.localUrl})`"
        >
          <!-- <img v-if="item.remoteUrl" :src="item.remoteUrl" /> -->
          <div class="inputView__layer__photo__shadow">
            <img
              class="inputView__layer__photo__shadow__close"
              :src="images.close_white"
              @click="closePhotoView(index)"
              v-if="item.progress === 100"
            />
            <span
              class="inputView__layer__photo__shadow__percent"
              v-if="item.progress !== 100"
            >{{item.progress === -1?"上传失败":item.progress+"%"}}</span>
          </div>
        </div>
        <div class="inputView__layer__photo inputView__layer__photo--add" @click="uploadPhoto()">
          <img :src="images.add" />
          <input
            type="file"
            ref="uploadPhoto"
            multiple="multiple"
            accept="image/*"
            @change="uploadPhoto_change"
            style="display:none;"
          />
          <input
            type="file"
            ref="uploadPhotoSingle"
            accept="image/*"
            @change="uploadPhoto_change"
            style="display:none;"
          />
        </div>
      </div>

      <div class="inputView__layer__videos" v-else-if="type==='video'">
        <div class="video__progressView" v-if="layer_video.progress.show">
          <div class="video__progressBar">
            <span class="video__progressBar__loadingBar">
              <em :style="`width:${layer_video.progress.percent}%`"></em>
            </span>
            <span
              class="video__btn--cancel"
              v-if="layer_video.progress.percent !== 100"
              @click="cancelUploadVideo()"
            >取消上传</span>
            <span class="video__btn--again" v-else @click="uploadVideo()">重新上传</span>
          </div>
          <div class="video__progressView__text">
            <span class="video__progressView__text--percent">已上传: {{layer_video.progress.percent}}%</span>
            <span
              class="video__progressView__text--size"
            >{{getLoadSize}} / {{getTotalSize}}</span>
          </div>
        </div>
        <span class="video__btn--upload" v-else @click="uploadVideo()">上传视频</span>

        <div class="video__posterView">
          <label>封面</label>
          <div
            class="video__posterView__img"
            :style="{ backgroundImage: `url(${layer_video.poster_url})` }"
            @click="uploadPoster()"
          >
            <span class="video__posterView__img--percent" v-if="layer_video.poster_percent !== 100 && layer_video.poster_percent !== 0">{{layer_video.poster_percent}}%</span>
            <em class="video__posterView__text">设置视频封面</em>
            <input
              ref="uploadPoster"
              type="file"
              accept="image/*"
              style="display:none"
              @change="uploadPoster_change"
            />
          </div>
        </div>

        <video
          ref="videoPlayer"
          poster="封面图路径"
          x5-playsinline
          playsinline
          webkit-playsinline
          preload="auto"
          :src="layer_video.video_url"
          style="display:none"
          @loadeddata="loadeddata"
        ></video>
        <input
          type="file"
          ref="uploadVideo"
          accept="video/*"
          @change="uploadVideo_change"
          style="display:none;"
        />
      </div>

      <div class="inputView__layer__emoijs" v-else-if="type==='emoij'">
        <div
          class="inputView__layer__emoij"
          v-for="(value, key, index) in layer_emoijs"
          :key="index"
          @click="chooseEmoij(value, key)"
        >
          <img
            class="inputView__layer__emoij__img"
            v-if="value.src"
            :src="value.src"
            :alt="key"
            :title="key"
          />
          <span class="inputView__layer__emoij__text" v-else>{{value.text}}</span>
        </div>
      </div>

      <div class="inputView__layer__videos" v-if="type==='3d-model'">
        <template v-if="type==='3d-model-vox'">
        <div class="uploadView">
          <input type="file" ref="upload3DModel_vox" accept=".vox" @change="upload3DModel_change_vox" style="display:none;"/>
          <span class="btn" @click="upload3DModel('vox')">上传.vox文件</span>
          <div class="progressView" v-if="model_3d.vox_progress.show">
            <div class="progressBar">
              <span class="loadingBar">
                <em :style="`width:${model_3d.vox_progress.percent}%`"></em>
              </span>
            </div>
            <div class="progressText">
              <span class="percent">已上传: {{model_3d.vox_progress.percent}}%</span>
              <span class="size">{{getLoadSize_vox()}} / {{getTotalSize_vox()}}</span>
            </div>
          </div>
        </div>
        </template>

        <template>
        <p style="color:#808080; font-size:12px;margin-bottom:10px;">obj 文件为必填，mtl文件、png文件选填<br>obj、mtl、png 文件名要与导出的文件名保持一致</p>
        <div class="uploadView">
          <input type="file" ref="upload3DModel_obj" accept=".obj" @change="upload3DModel_change_obj" style="display:none;"/>
          <span class="btn" @click="upload3DModel('obj')">上传.obj文件</span>
          <div class="progressView" v-if="model_3d.obj_progress.show">
            <div class="progressBar">
              <span class="loadingBar">
                <em :style="`width:${model_3d.obj_progress.percent}%`"></em>
              </span>
            </div>
            <div class="progressText">
              <span class="percent">已上传: {{model_3d.obj_progress.percent}}%</span>
              <span class="size">{{getLoadSize_obj()}} / {{getTotalSize_obj()}}</span>
            </div>
          </div>
        </div>

        <div class="uploadView">
          <input type="file" ref="upload3DModel_mtl" accept=".mtl" @change="upload3DModel_change_mtl" style="display:none;"/>
          <span class="btn" @click="upload3DModel('mtl')">上传.mtl文件</span>
          <div class="progressView" v-if="model_3d.mtl_progress.show">
            <div class="progressBar">
              <span class="loadingBar">
                <em :style="`width:${model_3d.mtl_progress.percent}%`"></em>
              </span>
            </div>
            <div class="progressText">
              <span class="percent">已上传: {{model_3d.mtl_progress.percent}}%</span>
              <span class="size">{{getLoadSize_mtl()}} / {{getTotalSize_mtl()}}</span>
            </div>
          </div>
        </div>

        <div class="uploadView">
          <input type="file" ref="upload3DModel_png" accept=".png" @change="upload3DModel_change_png" style="display:none;"/>
          <span class="btn" @click="upload3DModel('png')">上传.png文件</span>
          <div class="progressView" v-if="model_3d.png_progress.show">
            <div class="progressBar">
              <span class="loadingBar">
                <em :style="`width:${model_3d.png_progress.percent}%`"></em>
              </span>
            </div>
            <div class="progressText">
              <span class="percent">已上传: {{model_3d.png_progress.percent}}%</span>
              <span class="size">{{getLoadSize_png()}} / {{getTotalSize_png()}}</span>
            </div>
          </div>
        </div>
        </template>
      </div>

    </div>
  </div>
</template>
<script>
import {
  IMG_PHOTO_ORANGE,
  IMG_PHOTO_BLUE,
  IMG_VIDEO,
  IMG_EMOIJ,
  IMG_CLOSE,
  IMG_ADD,
  IMG_CLOSE_WHITE,
  EMOTIONS_CHAR
} from "../../assets";
import {
  UPLOAD_MANY_IMAGE, 
  UPLOAD_SINGLE_IMAGE,
  UPLOAD_MANY_IMAGE_WITH_TOKEN,
  UPLOAD_SINGLE_IMAGE_WITH_TOKEN
} from '@/utils'

import { types as ToastTypes } from "@/store/modules/toast";
import { mapState, mapGetters, mapMutations, mapActions } from "vuex";

var emoij_data = [];
var arr = [];
for (var i = 0; i < 100; i++) {
  arr.push(i);
}
emoij_data = arr;

export default {
  name: "ResourceView",
  components: {},
  props: {
    offsetLeft: {
      type: Number,
      default: 0
    },
    type: {
      type: String,
      default: "photo"
    }
  },
  data() {
    return {
      images: {
        photo: IMG_PHOTO_ORANGE,
        video: IMG_VIDEO,
        photo_blue: IMG_PHOTO_BLUE,
        emoij: IMG_EMOIJ,
        close: IMG_CLOSE,
        add: IMG_ADD,
        close_white: IMG_CLOSE_WHITE
      },
      // layer_emoijs:emoij_data,
      // 表情
      layer_emoijs: EMOTIONS_CHAR,
      // 图片
      layer_photos: [],

      // 视频
      layer_video: {
        subscription:null,
        poster_url: "",
        poster_percent:0,
        video_url: "",
        progress: {
          show: false,
          load_size: 0,
          total_size: 0,
          percent: 0,
        },
        remote_poster_url:'',
        remote_video_url:''
      },

      // 图片(传到服务器的)
      remoteUrls: [],

      // 3d-model
      model_3d: {
        tag: '',
        obj_progress: {
          // 是否打开进度条
          show: false,
          // 已上传大小
          load_size: 0,
          // 总大小
          total_size: 0,
          // 进度
          percent: 0,
        },
        mtl_progress: {
          // 是否打开进度条
          show: false,
          // 已上传大小
          load_size: 0,
          // 总大小
          total_size: 0,
          // 进度
          percent: 0,
        },
        png_progress: {
          // 是否打开进度条
          show: false,
          // 已上传大小
          load_size: 0,
          // 总大小
          total_size: 0,
          // 进度
          percent: 0,
        },
        vox_progress: {
          // 是否打开进度条
          show: false,
          // 已上传大小
          load_size: 0,
          // 总大小
          total_size: 0,
          // 进度
          percent: 0,
        },
        // 用于取消上传
        subscription:null,
        remote_3d_url:''
      }
    };
  },
  computed: {
    getLoadSize(){
      let size = 0;
      if(this.type === '3d-model'){
        size = this.model_3d.progress.load_size
      }else{
        size = this.layer_video.progress.load_size
      }
      return this.fileSize(size);
    },
    getTotalSize(){
      let size = 0;
      if(this.type === '3d-model'){
        size = this.model_3d.progress.total_size
      }else{
        size = this.layer_video.progress.total_size
      }
      return this.fileSize(size);
    }
  },
  watch:{
    type:{
      handler(newValue, oldValue){
        if(newValue !== oldValue){
          console.log("重置数据");
          this.resetData();
        }else{
          console.log("不做处理");
        }
      }
    }
  },
  methods: {
    ...mapMutations({
      showToast: ToastTypes.SHOW
    }),

    getLoadSize_vox(){
      return this.fileSize(this.model_3d.vox_progress.load_size)
    },
    getTotalSize_vox(){
      return this.fileSize(this.model_3d.vox_progress.total_size)
    },
    getLoadSize_obj(){
      return this.fileSize(this.model_3d.obj_progress.load_size)
    },
    getTotalSize_obj(){
      return this.fileSize(this.model_3d.obj_progress.total_size)
    },
    getLoadSize_mtl(){
      return this.fileSize(this.model_3d.mtl_progress.load_size)
    },
    getTotalSize_mtl(){
      return this.fileSize(this.model_3d.mtl_progress.total_size)
    },
    getLoadSize_png(){
      return this.fileSize(this.model_3d.png_progress.load_size)
    },
    getTotalSize_png(){
      return this.fileSize(this.model_3d.png_progress.total_size)
    },

    fileSize(size) {
      let str = "";
      if(size > 1024*1024*1024){
        size = (size/1024/1024/1024).toFixed(2)
        str = String(size) + "GB"
      }else if(size > 1024*1024){
        size = (size/1024/1024).toFixed(2)
        str = String(size) + "MB"
      }else if(size > 1024){
        size = (size/1024).toFixed(2)
        str = String(size) + "KB"
      }else{
        size = size.toFixed(2)
        str = String(size) + "B"
      }
      return str
    },

    closeLayerView() {
      console.log("关闭弹框");
      this.resetData();
      if (this.$parent.closeLayerView) {
        this.$parent.closeLayerView();
      }
    },
    //选择表情
    chooseEmoij(value, key) {
      if (this.$parent.setInputEmoijs) {
        this.$parent.setInputEmoijs(key);
      }
    },
    //上传图片
    uploadPhoto() {
      if(this.type === 'comment_photo'){
        // 单选
        this.$refs.uploadPhotoSingle.click()
      }else{
        // 多选
        this.$refs.uploadPhoto.click();
      }
    },

    //移除已上传的图片
    closePhotoView(i) {
      this.remoteUrls = this.remoteUrls.filter((item, index) => {
        return item.originUrl !== this.layer_photos[i]["localUrl"];
      });

      this.layer_photos = this.layer_photos.filter((item, index) => {
        return index !== i;
      });

      let images = this.remoteUrls.map((item, index) => {
        return item.remoteUrl;
      });

      // console.log(this.remoteUrls, images, this.layer_photos);
      if (this.$parent.setInputImages) {
        this.$parent.setInputImages(images, this.type);
      }
    },
    //图片选择之后的处理
    uploadPhoto_change(e) {
      let files = e.target.files;
      if(!files.length) return

      let localUrls = [];
      for (var i = 0; i < files.length; i++) {
        let imgSrc = window.URL.createObjectURL(files[i]);
        localUrls.push({ localUrl: imgSrc, progress: 0, file: files[i] });
      }
      // console.log(files[0], window.URL.createObjectURL(files[0]), window.URL.createObjectURL(files[0]))
      // console.log(localUrls);
      if(this.type === 'comment_photo'){
        this.layer_photos = localUrls
      }
      else{
        this.layer_photos = this.layer_photos.concat(localUrls);
      }

      UPLOAD_MANY_IMAGE(
        localUrls,
        remoteUrls => {
          if(this.type === 'comment_photo'){
            this.remoteUrls = remoteUrls;
          }else{
            this.remoteUrls = this.remoteUrls.concat(remoteUrls);
          }
          let images = this.remoteUrls.map((item, index) => {
            return item.remoteUrl;
          });
          // console.log("最终的图片", images, this.remoteUrls);

          if (this.$parent.setInputImages) {
            this.$parent.setInputImages(images, this.type);
          }
        },
        (progress, index) => {
          var tempLocalUrl = localUrls[index]
          var tempLayerPhoto = this.layer_photos.find((item, index) => {
            return item["localUrl"] == tempLocalUrl["localUrl"];
          });
          tempLayerPhoto["progress"] = parseInt(progress);
          // this.layer_photos[index]["progress"] = parseInt(progress);
        }
      );
    },

    //取消视频上传
    cancelUploadVideo() {
      this.layer_video.progress.show = false;
      this.layer_video.subscription.unsubscribe();
    },
    //上传视频点击事件
    uploadVideo() {
      this.$refs.uploadVideo.click();
    },
    //上传视频封面图点击事件
    uploadPoster() {
      this.$refs.uploadPoster.click();
    },
    //视频选择之后的处理
    uploadVideo_change(e) {
      // console.log(e);
      let files = e.target.files;
      this.layer_video.video_url = window.URL.createObjectURL(files[0]);

      this.layer_video.progress.show = true

      let percent = 0,
        load_size = 0,
        total_size = 0;
      total_size = files[0].size;
      load_size = 0.01 * percent * total_size;

      this.layer_video.progress.total_size = total_size;
      this.layer_video.progress.load_size = load_size;
      this.layer_video.progress.percent = percent;

      //上传视频
      UPLOAD_SINGLE_IMAGE(files[0], (url)=>{
        console.log("视频 URL: ",url);
        this.layer_video.remote_video_url = url;

        if (this.$parent.setInputVideos) {
          this.$parent.setInputVideos(this.layer_video.remote_video_url);
        }
      }, (progress)=>{
        // console.log(progress);
        percent = parseInt(progress);
        load_size = 0.01 * percent * total_size;

        this.layer_video.progress.load_size = load_size;
        this.layer_video.progress.percent = percent;
      }, (subscription)=>{
        this.layer_video.subscription = subscription;
      })
    },
    //监听视频第一帧加载完成
    loadeddata(e) {
      let scale = 0.8;
      let video = e.path[0];
      var canvas = document.createElement("canvas"); // canvas画布
      canvas.width = video.videoWidth * scale;
      canvas.height = video.videoHeight * scale;
      canvas
        .getContext("2d")
        .drawImage(video, 0, 0, canvas.width, canvas.height); // 画图
      // video.setAttribute('poster', canvas.toDataURL('image/png', 1))// 关键一步 —— 设置标签的 poster 属性的值为 base64 编译过后的canvas绘图。
      let img = canvas.toDataURL("image/png", 1);
      this.layer_video.poster_url = img;

      //上传封面
      this.uploadPosterEvent(this.dataURItoBlob(img));
    },
    //视频封面图选择之后的处理
    uploadPoster_change(e) {
      let files = e.target.files;
      // console.log("视频封面图:", files);
      let imgSrc = window.URL.createObjectURL(files[0]);
      this.layer_video.poster_url = imgSrc;
      this.uploadPosterEvent(files[0]);
    },
    //上传单个资源事件
    uploadPosterEvent(blob){
      UPLOAD_SINGLE_IMAGE(blob, (url)=>{
        console.log("封面图 URL(自定义): ",url);
        this.layer_video.remote_poster_url = url;
        if (this.$parent.setInputVideosPoster) {
          this.$parent.setInputVideosPoster(this.layer_video.remote_poster_url);
        }
      }, (progress)=>{
        this.layer_video.poster_percent = parseInt(progress);
      })
    },
    //将 dataURL -> blob
    dataURItoBlob (dataURI) {
      var byteString = atob(dataURI.split(',')[1])
      var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0]
      var ab = new ArrayBuffer(byteString.length)
      var ia = new Uint8Array(ab)
      for (var i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i)
      }
      return new Blob([ab], {type: mimeString})
    },

    // --------3d-model
    upload3DModel(tag){
      if(tag === 'obj'){
        this.$refs.upload3DModel_obj.click()
      }else if(tag === 'mtl'){
        this.$refs.upload3DModel_mtl.click()
      }else if(tag === 'png'){
        this.$refs.upload3DModel_png.click()
      }else if(tag === 'vox'){
        this.$refs.upload3DModel_vox.click()
      }
    },
    upload3DModel_change_vox(e){
      this.upload3DModel_change(e.target.files[0], 'vox')
    },
    upload3DModel_change_obj(e){
      this.upload3DModel_change(e.target.files[0], 'obj')
    },
    upload3DModel_change_mtl(e){
      this.upload3DModel_change(e.target.files[0], 'mtl')
    },
    upload3DModel_change_png(e){
      this.upload3DModel_change(e.target.files[0], 'png')
    },
    upload3DModel_change(file, tag){
      let percent = 0,
        load_size = 0,
        total_size = file.size;

      load_size = 0.01 * percent * total_size;

      let is_use_filename =  true

      if(tag === 'obj'){
        this.model_3d.obj_progress.show = true
        this.model_3d.obj_progress.total_size = total_size;
        this.model_3d.obj_progress.load_size = load_size;
        this.model_3d.obj_progress.percent = percent;
      }else if(tag === 'png'){
        this.model_3d.png_progress.show = true
        this.model_3d.png_progress.total_size = total_size;
        this.model_3d.png_progress.load_size = load_size;
        this.model_3d.png_progress.percent = percent;
      }else if(tag === 'mtl'){
        this.model_3d.mtl_progress.show = true
        this.model_3d.mtl_progress.total_size = total_size;
        this.model_3d.mtl_progress.load_size = load_size;
        this.model_3d.mtl_progress.percent = percent;
      }else if(tag === 'vox'){
        this.model_3d.vox_progress.show = true
        this.model_3d.vox_progress.total_size = total_size;
        this.model_3d.vox_progress.load_size = load_size;
        this.model_3d.vox_progress.percent = percent;
        is_use_filename = false
      }
      
      UPLOAD_SINGLE_IMAGE_WITH_TOKEN(file, (url)=>{
        if (url && (url.includes(".obj") || url.includes(".vox")) && this.$parent.setInputModel) {
          this.model_3d.remote_3d_url = url;
          this.$parent.setInputModel(url);
        }
      }, (progress)=>{
        let temp_percent = parseInt(progress)
        load_size = 0.01 * temp_percent * total_size;

        if(tag === 'obj'){
          this.model_3d.obj_progress.load_size = load_size;
          this.model_3d.obj_progress.percent = temp_percent;
        }else if(tag === 'png'){
          this.model_3d.png_progress.load_size = load_size;
          this.model_3d.png_progress.percent = temp_percent;
        }else if(tag === 'mtl'){
          this.model_3d.mtl_progress.load_size = load_size;
          this.model_3d.mtl_progress.percent = temp_percent;
        }else if(tag === 'vox'){
          this.model_3d.vox_progress.load_size = load_size;
          this.model_3d.vox_progress.percent = temp_percent;
        }
        
      },(subscription)=>{
        this.model_3d.subscription = subscription;
      },is_use_filename)

    },
    upload3DModel_change1(file){
      let files = e.target.files;
      let has_obj = false
      let has_mtl = false
      let has_png = false
      let obj_name = ''
      let mtl_name = ''
      let png_name = ''
      var total_size = 0
      for(var i=0; i<files.length; i++){
        if(files[i]["name"].includes(".obj")){
          has_obj = true
          obj_name = files[i]["name"].split(".obj")[0]
          total_size += files[i].size
        }
        if(files[i]["name"].includes(".mtl")){
          has_mtl = true
          mtl_name = files[i]["name"].split(".mtl")[0]
          total_size += files[i].size
        }
        if(files[i]["name"].includes(".png")){
          has_png = true
          png_name = files[i]["name"].split(".png")[0]
          total_size += files[i].size
        }
      }
      if(!has_obj || !has_mtl || !has_png){
        this.showToast({message:"请上传一个obj文件、mtl 文件、png 文件"})
        return
      }
      if(obj_name !== mtl_name || obj_name !== png_name){
        this.showToast({message:"请保持obj、mtl、png文件名称一致"})
        return
      }
      if(files.length !== 3){
        this.showToast({message:"请一次性上传3个文件(obj、mtl、png)"})
        return;
      }
      console.log("开始上传", obj_name, mtl_name, png_name)

      this.model_3d.progress.show = true

      let total_percent = 0,
        single_percent = 0,
        load_size = 0;

      load_size = 0.01 * (total_percent+single_percent) * total_size;

      this.model_3d.progress.total_size = total_size;
      this.model_3d.progress.load_size = load_size;
      this.model_3d.progress.percent = (total_percent+single_percent);

      let localUrls = [];
      for (var i = 0; i < files.length; i++) {
        let imgSrc = "";
        localUrls.push({ localUrl: imgSrc, progress: 0, file: files[i] });
      }
      
      UPLOAD_MANY_IMAGE_WITH_TOKEN(
        localUrls,
        remoteUrls => {
          // console.log(remoteUrls);
          let temp_remoteUrls = remoteUrls.map((item, index) => {
            return item.remoteUrl;
          });
          let url = temp_remoteUrls.find(item=>item.includes(".obj"))
          if(url){
            this.model_3d.remote_3d_url = url;
            if (this.$parent.setInputModel) {
              this.$parent.setInputModel(this.model_3d.remote_3d_url);
            }
          }
        },
        (progress, index) => {
          // console.log(progress, index);
          let temp_percent = Math.round(parseInt(progress) / 3)
          if(parseInt(progress) !== 100){
            single_percent = temp_percent
          }else{
            single_percent = 0
            total_percent += temp_percent
          }
          if(index === 2){
            total_percent = 100
          }
          
          load_size = 0.01 * (total_percent+single_percent) * total_size;
          this.model_3d.progress.load_size = load_size;
          this.model_3d.progress.percent = total_percent+single_percent;
          // console.log(percent, load_size, total_size);
        },(subscription)=>{
          this.model_3d.subscription = subscription;
        },true);
        
    },
    cancelUpload3DModel() {
      this.model_3d.obj_progress.show = false;
      this.model_3d.subscription.unsubscribe();
    },

    resetData(){
      this.layer_photos = [];
      this.remoteUrls = [];
      this.layer_video.poster_url = ''
      this.layer_video.video_url = ''
      this.layer_video.poster_percent = 0
      this.layer_video.progress.show = false
      this.layer_video.remote_poster_url = ''
      this.layer_video.remote_video_url = ''
      this.model_3d.obj_progress.show = false
      this.model_3d.mtl_progress.show = false
      this.model_3d.png_progress.show = false
      this.model_3d.remote_3d_url = ''
      this.model_3d.vox_progress.show = false
    }
  },
  create() {},
  mounted() {
    this.resetData()
  }
};
</script>

<style scoped lang="less">
/*图片，表情，视频等临时窗口*/
.inputView__layer {
  position: absolute;
  top: calc(100% - 10px);
  z-index: 100;
}
.inputView__layer__arrow {
  display: inline-block;
  transform: rotate(45deg);

  margin-left: 30px; /*30, 90, 160*/
  width: 10px;
  height: 10px;
  background-color: white;
  /* border-bottom-right-radius: 10px; */
  border: 1px solid #ccc;
  border-right-color: transparent;
  border-bottom-color: transparent;
}
.inputView__layer__content {
  margin-top: -10px;
  padding: 16px 16px 10px 16px;
  /* width: 252px; */
  /* height: 200px; */
  margin-left: -6px;

  background-color: #fff;
  border-radius: 3px;
  border: solid 1px #ccc;
  box-shadow: 0 4px 20px 1px rgba(0, 0, 0, 0.2);
}
.inputView__layer__header {
  text-align: right;
}
.inputView__layer__header__close {
  height: 15px;
  margin-bottom: 5px;
  cursor: pointer;
}

/*
** 图片
*/
.inputView__layer__photos {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  margin-left: -6px;
  width: 258px;
}
.inputView__layer__photo {
  width: 80px;
  height: 80px;
  margin-left: 6px;
  margin-bottom: 6px;
  /* background-color: orange; */
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;

  position: relative;
}
.inputView__layer__photo > img {
  width: 100%;
  height: 100%;
}
.inputView__layer__photo--add {
  border: 2px dashed #ccc;
  width: 76px;
  height: 76px;
  background-color: transparent;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
.inputView__layer__photo--add > img {
  width: 25px;
  height: 25px;
}
.inputView__layer__photo__shadow {
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.2);
  /* position: relative; */

  display: flex;
  justify-content: center;
  align-items: center;
}
.inputView__layer__photo__shadow__percent {
  color: #fff;
  font-size: 20px;
}
.inputView__layer__photo__shadow__close {
  position: absolute;
  right: 5px;
  top: 5px;
  height: 10px;
  cursor: pointer;
}

/*
** 表情
*/
.inputView__layer__emoijs {
  width: 324px;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}
.inputView__layer__emoij {
  border: 1px solid #e8e8e8;
  width: 26px;
  height: 26px;
  margin-top: -1px;
  margin-right: -1px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
.inputView__layer__emoij__img {
  width: 20px;
}

/*
** 视频
*/
.inputView__layer__videos {
  width: 300px;
}
.video__progressView {
}
.video__btn--upload {
  background: #ff8140;
  display: inline-block;
  height: 28px;
  line-height: 29px;
  border: 1px solid #f77c3d;
  color: #ffffff;
  font-size: 14px;
  width: 60px;
  padding: 0 10px 0 10px;
  border-radius: 2px;
  text-align: center;
  outline: none;
  margin-left: calc((100% - 82px) / 2);
  cursor: pointer;
}
.video__progressBar {
  display: flex;
  justify-content: center;
  align-items: center;
}
.video__progressBar__loadingBar {
  display: inline-block;
  width: 250px;
  height: 10px;
  margin: 5px 0;
  border-radius: 6px;
  background: #f2f2f5;
  overflow: hidden;
  text-align: left;
  font-size: 0;
  margin-right: 30px;
  flex: 1;
}
.video__progressBar__loadingBar em {
  display: inline-block;
  height: 10px;
  background: #fa7d3c;
  vertical-align: top;
  width: 0;
}
.video__btn--again,
.video__btn--cancel {
  line-height: 20px;
  color: #808080;
  font-size: 12px;
  cursor: pointer;
}
.video__btn--cancel:hover {
  color: #fa7d3c;
}
.video__progressView__text {
  line-height: 20px;
  color: #808080;
  font-size: 12px;
}
.video__progressView__text--percent {
}
.video__progressView__text--size {
  margin-left: 30px;
}

.video__posterView {
  margin-top: 20px;
  margin-left: 10px;
  display: flex;
  flex-direction: row;
}
.video__posterView label {
  font-size: 14px;
  line-height: 30px;
  color: #333333;
  margin-right: 5px;
}
.video__posterView__img {
  width: 160px;
  height: 80px;
  margin-left: 6px;
  margin-bottom: 6px;
  background-color: #e1e1e1;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;

  position: relative;
  cursor: pointer;
}
.video__posterView__img--percent{
      color: white;
    background: linear-gradient( to bottom, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.4) 100% );
    display: inline-block;
    width: 100%;
    height: 100%;
    
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 16px;
}
.video__posterView__text {
  position: absolute;
  left: 0;
  bottom: 0;
  right: 0;
  line-height: 17px;
  display: block;
  color: #ffffff;
  background: linear-gradient(
    to bottom,
    rgba(0, 0, 0, 0) 0%,
    rgba(0, 0, 0, 0.4) 100%
  );
  padding: 0 5px;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
}
.uploadView{
  display: flex;
  flex-direction: row;
  font-size: 12px;
  align-items: center;
  margin-bottom: 10px;
  .btn{
    background: #ff8140;
    display: inline-block;
    height: 28px;
    line-height: 29px;
    border: 1px solid #f77c3d;
    color: #ffffff;
    font-size: 12px;
    padding: 0 5px 0 5px;
    border-radius: 2px;
    text-align: center;
    outline: none;
    // width: 100px;
    cursor: pointer;
    margin-right: 10px;
  }
  .progressView{
    flex: 1;
    .progressBar{
      flex:1;
      display: flex;
      justify-content: center;
      align-items: center;
      .loadingBar{
        flex: 1;
        // display: inline-block;
        // width: 250px;
        height: 10px;
        margin: 5px 0;
        border-radius: 6px;
        background: #f2f2f5;
        overflow: hidden;
        text-align: left;
        font-size: 0;
        // margin-right: 30px;
        flex: 1;
        em{
          display: inline-block;
          height: 10px;
          background: #fa7d3c;
          vertical-align: top;
          width: 0;
        }
      }
    }
    .progressText{
      line-height: 20px;
      color: #808080;
      font-size: 12px;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      .percent{
        // margin-right: 30px;
      }
      .size{

      }
    }
  }
}
</style>


